import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import starWhite from "../assets/sportLogo.png";
import fb from "../assets/fb.png";
import insta from "../assets/insta.png";
import tiktok from "../assets/tiktok.png";
import { getReviewsById, getAllProducts } from "../Utils/Utils";
import ImageSlider from "./MUI/ImagesSilder";
import Tabs from "./MUI/Tabs";
import TableComponent from "./MUI/TableComponent";

import {} from "../Utils/Utils";

const ProductDetails = ({
  product,
  pageContent,
  darkMode,
  setSelectedVariant,
}) => {
  console.log(product);
  const [reviews, setReviews] = useState([]);
  const [emailNotif, setEmailNotif] = useState("");
  const [formMsg, setFormMsg] = useState("");

  const [activeVariantIndex, setActiveVariantIndex] = useState(0);

  const columns = [
    { key: "Specification", label: "Specification" },
    { key: "Value", label: "Value" },
  ];

  const generateSpecsData = (item) => {
    return [
      {
        Specification: "Brand",
        Value: item && item.brandName ? item.brandName : "N/A",
      },
      {
        Specification: "Product Name",
        Value: item && item.productName ? item.productName : "N/A",
      },
      {
        Specification: "Availability Date",
        Value: item && item.availabilityDate ? item.availabilityDate : "N/A",
      },

      {
        Specification: "Price",
        Value: item && item.price ? `${item.price} DA` : "N/A",
      },
      {
        Specification: "Tags",
        Value: (item && item.tags?.join(", ")) || "N/A",
      },
    ];
  };

  const generateTabsData = (item) => {
    const specsData = generateSpecsData(item);

    return [
      {
        buttonContent: <p>Specification</p>,
        content: (
          <div>
            <TableComponent data={specsData} columns={columns} />
          </div>
        ),
      },
      {
        buttonContent: <p>Manuals</p>,
        content: (
          <div>
            <p>
              Download user manuals and guides for product setup and
              maintenance.
            </p>
            {item &&
              item.maunalFile?.map((file, idx) => (
                <a
                  key={idx}
                  href={file}
                  target="_blank"
                  rel="noreferrer"
                  className="my-20"
                >
                  Manual {idx + 1}.pdf
                </a>
              ))}
          </div>
        ),
      },
    ];
  };

  const variantTabs = [
    {
      buttonContent: (
        <div
          className="flex-column align-items-center px-10"
          onClick={() => {
            setActiveVariantIndex(0);
            setSelectedVariant(null);
          }}
        >
          <img
            className="tab-icon"
            alt=""
            src={product && product.imgSrc?.[0]}
          />
          <p className="mx-10 py-10 small-text bold center-text">
            {product && product.name ? product.name : null}
          </p>
        </div>
      ),
      content: (
        <Tabs
          tabs={generateTabsData(product)}
          className={
            darkMode ? "var-tabs small-text dark-mode" : "var-tabs small-text"
          }
        />
      ),
    },
    ...(product &&
    Array.isArray(product.varients) &&
    product.varients.length > 0
      ? product.varients.map((variant, idx) => ({
          buttonContent: (
            <div
              className="flex-column align-items-center px-10"
              onClick={() => {
                setActiveVariantIndex(idx + 1);
                setSelectedVariant(idx + 1);
              }}
            >
              <img className="tab-icon" alt="" src={variant.imagesUrls?.[0]} />
              <p className="mx-10 py-10 small-text bold center-text center-text">
                {variant && variant.productName ? variant.productName : null}
              </p>
            </div>
          ),
          content: (
            <Tabs
              tabs={generateTabsData(variant)}
              className={
                darkMode
                  ? "sec-tabs small-text dark-mode"
                  : "sec-tabs small-text "
              }
            />
          ),
        }))
      : []),
  ];

  useEffect(() => {
    console.log(pageContent);
    console.log(product);
    /*
    getAllProducts().then((all) => {
      console.log("getAllProducts then..");

      const productsArray = Object.values(all);
      const found = productsArray.find((p) => p.id === product.id);
      if (found) {

        // fetch reviews after product is set
        getReviewsById(found.id).then((res) => {
          setReviews(res);
        });
      }
    });

    */
  }, []);

  return (
    product && (
      <motion.div
        id=""
        className={
          darkMode
            ? "dark-mode prodcutDetails   justify-space-between"
            : "prodcutDetails   justify-space-between "
        }
        initial={{ top: "50px", opacity: 0 }}
        animate={{ top: "0", opacity: 1, transition: { delay: 0.5 } }}
      >
        <Tabs
          tabs={variantTabs}
          className={darkMode ? "dark-modee vars-tab" : "vars-tab "}
        />
      </motion.div>
    )
  );
};

export default ProductDetails;
